import React from "react";
import { Button, Row } from "reactstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const PayButton = ({
  disabled,
  currency,
  reservationWarningShown,
  finalPrice,
  color,
  userTableInfo,
  handlePayButton,
  loading,
  tableNumber,
  distanceInMeters,
}) => {
  const { uid } = useSelector((state) => state.authUser);
  const { orderType, addressDetails, checkoutQuestions } = useSelector(
    (state) => state.cart
  );
  const history = useHistory();

  const handleClick = (e) => {
    if (uid) {
      handlePayButton(e);
    } else {
      history.push("/main?isGoogle=true");
    }
  };

  const getDisableReason = () => {
    if (loading) return "";

    if (reservationWarningShown)
      return `⚠️ You already have an active order at ${
        userTableInfo?.restaurantName || "restaurant"
      }. Please complete or cancel it before ordering from a new one.`;

    const hasEmptyMandatoryField = checkoutQuestions?.some(
      (question) => question.isMandatory && !question.answer
    );

    if (distanceInMeters > 100)
      return "📍 Address must be within 100 meters of the restaurant";

    if (orderType === "dinein" && !tableNumber)
      return "🍽️ Table is not selected.";

    if (hasEmptyMandatoryField)
      return "📝 Please answer all mandatory questions.";

    if (finalPrice > 10000) return "🚫 Order limit exceeded (Max: 10,000).";

    if (
      orderType === "delivery" &&
      (!addressDetails || !addressDetails.address)
    )
      return "📍 Delivery address is missing.";

    return "⚠️ Something went wrong. Please check your details.";
  };

  const tooltipMessage = getDisableReason();

  return (
    <Row className="d-flex justify-content-center p-3">
      <div className="tooltip-wrapper">
        <Button
          style={{ background: color }}
          className="top_cards__addtocart fs--16 fw--400 my-4"
          onClick={handleClick}
          disabled={disabled || loading}
        >
          {uid ? `Pay - ${currency || "$"} ${finalPrice}` : "Login to Proceed"}
        </Button>

        {tooltipMessage && !loading && (disabled || loading) && (
          <div className="custom-tooltip">{tooltipMessage}</div>
        )}
      </div>
    </Row>
  );
};

export default PayButton;
